let config = {
	id: null,
	env: null,
	scriptSrc: 'https://www.googletagmanager.com/gtm.js?id=',
	dataLayer: 'dataLayer',
}

function loadScript() {
	window.addEventListener(
		'load',
		function (e) {
			const script = document.createElement('script')

			script.src = config.scriptSrc + config.id + '&l=' + config.dataLayer

			document.head.appendChild(script)
		},
		{ once: true },
	)
}

function createGtm(Vue) {
	window[config.dataLayer] = window[config.dataLayer] || []

	function gtm() {
		window[config.dataLayer].push(arguments)
	}

	gtm({
		'gtm.start': new Date().getTime(),
		event: 'gtm.js',
	})

	return (Vue.prototype.$gtm = Vue.$gtm = gtm)
}

export default function (Vue, options = {}) {
	config = { ...config, ...options }
	createGtm(Vue)

	if (config.id && config.env === 'production') {
		loadScript()
	}
}
